const isClient: boolean = typeof window === 'object'

export default isClient